<template>
    <div class="card cell-card" :style="[backgroundStyle, fullScreenStyle]"
         @click="isShowHelpDialog = false">
        <div class="card-header d-flex justify-content-between align-items-center" @click.prevent="fullScreen"
             style="cursor: pointer;" :style="[headerStyle]" ref="header">
            <div>{{name}}</div>
            <div class="d-flex align-items-center">
                <div>
                    <font-awesome-icon :icon="infoIcon" style="cursor: pointer"
                                       class="mx-1" @click.stop="openInfo"/>
                </div>
            </div>
        </div>
        <div class="card-body" :style="[cardBodyStyle]">
            <ckeditor :editor="editorData.editor" v-model="value" :config="editorData.editorConfig"></ckeditor>
        </div>
        <Dialog v-model:visible="isShowHelpDialog" :header="name" @click="isShowHelpDialog = false"
                :pt="{
                    content: {
                        style: {'padding':'10px'}
                    },
                    header: {
                        style: {'padding':'10px'}
                    },
                    root: {
                        style: {'font-size': '0.85rem'}
                    }
                }">
            <div v-html="hint"></div>
        </Dialog>
    </div>
</template>

<script>
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import {faWindowMaximize, faWindowRestore, faInfoCircle} from "@fortawesome/free-solid-svg-icons";
    import {BalloonEditor} from '@ckeditor/ckeditor5-editor-balloon/src'
    import {Essentials} from '@ckeditor/ckeditor5-essentials/src';
    import {Bold, Italic, Underline, Strikethrough, Subscript, Superscript} from '@ckeditor/ckeditor5-basic-styles/src';
    import {Link} from '@ckeditor/ckeditor5-link/src';
    import {Paragraph} from '@ckeditor/ckeditor5-paragraph/src';
    import {List, TodoList} from '@ckeditor/ckeditor5-list/src'
    import {RemoveFormat} from '@ckeditor/ckeditor5-remove-format/src'
    import {Indent} from '@ckeditor/ckeditor5-indent/src'
    import {SpecialCharacters, SpecialCharactersEssentials} from '@ckeditor/ckeditor5-special-characters/src'
    import { BlockToolbar } from '@ckeditor/ckeditor5-ui/src';
    import Dialog from 'primevue/dialog'

    const toolbarItems = [
        'bold',
        'italic',
        'underline',
        'strikethrough',
        'subscript',
        'superscript',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        'todoList',
        '|',
        'outdent',
        'indent',
        '|',
        'specialCharacters',
        '|',
        'undo',
        'redo',
        'removeFormat'
    ]

    export default {
        name: "TableCell",
        props: {
            name: {
                type: String,
                required: true
            },
            modelValue: {
                type: String
            },
            bgColor: {
                type: String,
                default: '#FFFFFF'
            },
            hint: {
                type: String
            },
            rowcount: {
                type: Number,
                default: 1
            },
            maxHeight: {
                type: Number,
                default: 0
            }
        },
        emits: ['update:modelValue', 'update:height'],
        components: {
//            QuillEditor,
            FontAwesomeIcon,
            Dialog
        },
        mounted() {
            window.addEventListener("resize", this.resizeWindow);
            this.resizeWindow()
        },
        unmounted() {
            window.removeEventListener("resize", this.resizeWindow);
        },
        data: function () {
            return {
                backgroundStyle: {
                    backgroundColor: this.bgColor,
                },
                isFullScreen: false,
                isShowHelpDialog: false,
                infoIcon: faInfoCircle,
                headerHeight: null,
                editorData: {
                    editor: BalloonEditor,
                    editorConfig: {
                        plugins: [
                            Essentials,
                            Bold,
                            Italic,
                            Link,
                            Paragraph,
                            Underline,
                            Strikethrough,
                            Subscript,
                            Superscript,
                            List,
                            TodoList,
                            RemoveFormat,
                            Indent,
                            SpecialCharacters,
                            SpecialCharactersEssentials,
                            BlockToolbar
                        ],
                        blockToolbar: {
                            items: toolbarItems,
                            shouldNotGroupWhenFull: true
                        },
                        toolbar: {
                            items: toolbarItems
                        }
                    }
                },
            }
        },
        computed: {
            value: {
                get() {
                    return this.modelValue
                },
                set(value) {
                    this.$emit('update:modelValue', value)
                }
            },
            maxIcon: function () {
                return this.isFullScreen ? faWindowRestore : faWindowMaximize
            },
            fullScreenStyle: function () {
                if (this.isFullScreen) {
                    return {
                        position: 'fixed',
                        left: '0px',
                        top: '0px',
                        right: '0px',
                        bottom: '0px',
                        zIndex: '1000'
                    }
                } else {
                    return {}
                }
            },
            cardBodyStyle: function () {
                if (this.isFullScreen) {
                    return {
                        overflow: 'auto'
                    }
                } else {
                    return {}
                }
            },
            headerStyle: function () {
                if (this.maxHeight != 0) {
                    return {
                        minHeight: this.maxHeight + 'px'
                    }
                }
                return {}
            }
        },
        methods: {
            fullScreen() {
                this.isFullScreen = !this.isFullScreen
            },
            openInfo() {
                this.isShowHelpDialog = true
            },
            resizeWindow() {
                if (this.headerHeight != this.$refs.header.clientHeight) {
                    this.headerHeight = this.$refs.header.clientHeight
                    this.$emit('update:height', this.headerHeight)
                }
            }
        }
    }
</script>

<style scoped>
    .card-tooltip {
        position: fixed;
        border: 1px solid black;
        padding: 5px;
        background-color: white;
    }

    .cell-card .card-header, .cell-card .card-body {
        padding: 5px;
    }

    .cell-card {
        border-radius: 0;
    }
</style>
